<section class="py-10 lg:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <section
    class="container mx-auto rounded-3xl overflow-hidden bg-[#EAF6FF] flex flex-col xl:flex-row items-center"
  >
    <!-- Text -->
    <div class="py-7 px-5 lg:p-10 w-full xl:w-[50%] flex flex-col gap-3.5">
      <h2 class="font-bold text-4xl">Looking for Used Tesla for sale?</h2>
      <p>
        Welcome to Only Used Tesla - the top spot for exclusive Tesla listings.
        Whether you're keen to sell my Tesla or hoping to find your next ride,
        we make the process seamless. Dive into a world where only used Tesla
        vehicles take center stage. Ready to sell? Create an account or reach
        out to discover more!
      </p>
      <button
        *ngIf="(auth.isAuthenticated$ | async) === false"
        class="bg-OUT-Blue hover:bg-OUT-Blue/90 w-fit transition-colors duration-400 rounded-full px-4 py-2 text-white font-semibold cursor-pointer"
        (click)="login()"
      >
        Create Account
      </button>
      <button
        *ngIf="(auth.isAuthenticated$ | async) === true"
        class="bg-OUT-Blue hover:bg-OUT-Blue/90 w-fit transition-colors duration-400 rounded-full px-4 py-2 text-white font-semibold cursor-pointer"
        [routerLink]="'/used-tesla-for-sale'"
      >
        Explore Listings
      </button>
    </div>

    <!-- Image -->
    <img
      src="/assets/images/OUT-tesla-1.jpg"
      class="w-full xl:w-[50%] object-cover rounded-b-3xl lg:rounded-b-none max-h-[400px] lg:max-h-[500px]"
      alt=""
    />
  </section>
</section>
